import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=e8db25c4&scoped=true"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=e8db25c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db25c4",
  null
  
)

export default component.exports